// extracted by mini-css-extract-plugin
export default {"preview":"Preview_preview__oyPuE","section":"Preview_section__4t9s-","divider":"Preview_divider__jiEkS","footer":"Preview_footer__fo4Uu","canvas":"Preview_canvas__AmyKn"};